<template>
  <div>

      <h2>{{ authUser.name }}</h2>
      <p class="center no-spacing"> Email: <span>{{ authUser.email }}</span></p>
      <p class="center ninety-grey" ><small v-if="authUser.email_verified_at">
        Email Verified
      </small></p>

        <VerifyEmail v-if="!authUser.email_verified_at" class="center" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VerifyEmail from "./VerifyEmail";

export default {
  name: "AuthUser",
  components: {
    VerifyEmail,
  },
  computed: {
    ...mapGetters("auth", ["authUser"]),
  },
};
</script>
